"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryDealerIdLocationDto = void 0;
class InventoryDealerIdLocationDto {
    constructor(params) {
        if (!params) {
            return;
        }
        this.inventoryDealerIdId = params.inventoryDealerIdId;
        this.locationId = params.locationId;
    }
}
exports.InventoryDealerIdLocationDto = InventoryDealerIdLocationDto;
//# sourceMappingURL=InventoryDealerIdLocationDto.js.map